import React, { Component } from "react";
import { List } from "semantic-ui-react";
import { Table } from "semantic-ui-react";
import { Form } from 'semantic-ui-react'

export default class TariffSwitchingTimes extends Component {
  constructor(props) {
    super(props);
  
    this.state = {seasonIndex: 0, weekName: "1"};
 }



  render() {

  const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  if (this.props.tariff)
  {
    console.log(this.props.tariff)
  
  var seasons=[]

  if (Array.isArray(this.props.tariff.TariffSwitchingTable.Seasons))
      seasons=this.props.tariff.TariffSwitchingTable.Seasons
  else if (typeof this.props.tariff.TariffSwitchingTable.Seasons==='object')
    seasons=[this.props.tariff.TariffSwitchingTable.Seasons.Season] 

  var weekProfiles=[];
  if (Array.isArray(this.props.tariff.TariffSwitchingTable.WeekProfiles))
    weekProfiles=this.props.tariff.TariffSwitchingTable.WeekProfiles
  else if (typeof this.props.tariff.TariffSwitchingTable.Seasons==='object')
    weekProfiles=[this.props.tariff.TariffSwitchingTable.WeekProfiles.WeekProfile] 

  var weekProfile;
  weekProfile=weekProfiles.find(profile=>{return profile.WeekName===this.state.weekName})

  var dayProfiles=[];
  if (Array.isArray(this.props.tariff.TariffSwitchingTable.DayProfiles.DayProfile))
    dayProfiles=this.props.tariff.TariffSwitchingTable.DayProfiles.DayProfile
  else if (typeof this.props.tariff.TariffSwitchingTable.DayProfiles.DayProfile==='object')
    dayProfiles=[this.props.tariff.TariffSwitchingTable.DayProfiles.DayProfile] 

  const seasonOptions=seasons.map((season, i)=>{return {key: i, value: i, text: season.SeasonName}})

  return (<Form>
    <Form.Select options={seasonOptions} value={this.state.seasonIndex} label="Season" placeholder="Season" onChange={(event, data)=>{this.setState({seasonIndex: data.value, weekName: seasons[data.value].ReferencedWeekName})}}/>
    {weekProfile && <Table>
      {weekProfile.ReferencedElecDay.map(day=>{
        var dayProfile=dayProfiles.find(dayProfile=>{return dayProfile.Day===day['#text']})
        var profileSchedule=[];
        if (Array.isArray(dayProfile.ProfileSchedule))
        profileSchedule=dayProfile.ProfileSchedule
        else if (typeof dayProfile.ProfileSchedule==='object')
        profileSchedule=[dayProfile.ProfileSchedule] 
      
        return <Table.Row>
          <Table.Cell>{days[parseInt(day['@index'])-1]}</Table.Cell>
      <Table.Cell><List>{profileSchedule.map(tariffAction=>{return <List.Item>{tariffAction.StartTime.slice(0, 8)+ ' Rate '+tariffAction.TOUTariffAction}</List.Item>})}</List></Table.Cell>
        </Table.Row>
      })}
    </Table>}
  </Form>)
  
  }
  }

}
